var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Sentry from '@sentry/react';
import { startConversationReadClient, closeWebsocketConnection, createNewConversation } from '../conversation';
import { fetchTrainingFiles } from '../config';
import { fetchScribeSettings } from '../firebase';
import { fetchAvaWebAppSession } from './index';
import { logoutAndClean } from '../../utils/user';
import { getSocketIfExist } from '../../utils/getSocket';
export const initiateSession = (history, startConvo = false) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        dispatch({ type: 'LOADING_APP', status: true });
        const { scribeSession: { features, branchId, captioner, needInternalAudioAccess, microphoneAccess, showQuickSetup }, scribeConversation: { token }, } = getState();
        const request = localStorage.getItem('ava_request');
        let { search } = history.location;
        let path;
        if (features.scribe && !window.isElectron && !token && !branchId && !request) {
            path = '/web/scribe-dashboard';
            search = '';
        }
        else {
            path = '/web/transcript';
        }
        const socket = getSocketIfExist();
        if (!captioner || !(socket && socket.v1)) {
            yield closeWebsocketConnection()(dispatch, getState);
            yield fetchAvaWebAppSession()(dispatch, getState);
        }
        startConversationReadClient()(dispatch, getState);
        // Purposefully ignoring promise, as we only care about side effects.
        fetchScribeSettings()(dispatch, getState);
        if (features.scribe) {
            yield fetchTrainingFiles()(dispatch);
        }
        if (window.electronIPC) {
            window.electronIPC.sendDoneLoading();
        }
        if (startConvo && !needInternalAudioAccess && microphoneAccess === 'granted' && !showQuickSetup) {
            yield createNewConversation()(dispatch, getState);
        }
        else {
            dispatch({ type: 'LOADING_APP', status: false });
        }
        if (path) {
            history.push(`${path}${search}`);
        }
    }
    catch (err) {
        Sentry.captureException(err);
        // eslint-disable-next-line
        alert('Ava faced an unexpected error. We will reload the page to get it fixed. Please contact support@ava.me if the issue persist.');
        if (window.location.href.startsWith('https://web.ava.me')) {
            yield logoutAndClean();
            window.open('/', '_self');
        }
    }
});
